export const DVTJCUVCddSddvParentTabs = {
    USDING_SDDV_TAB: {title: 'Đang SDDV', id: 'dvtjcuv-cdd-using-sddv-tab'},
    PAUSE_SDDV_TAB: {title: 'Tạm dừng SDDV', id: 'dvtjcuv-cdd-pause-sddv-tab'},
    EVER_SDDV_TAB: {title: 'Từng SDDV', id: 'dvtjcuv-cdd-ever-sddv-tab'},
};